import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull } from "@/functions/Util";

export default class CentroCustoValidation extends DefaultValidation {
    
    validate(model, refs) {
        let validated = true;

        if (isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.idfin_centro_custoerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }

}